module.exports = __webpack_public_path__ + "static/img/modeler-fuzz.0e75072.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/modeler/modeler-fuzz.jpg
// module id = 1WBu
// module chunks = 12